import { useToast } from "../../../mantine/notifications/useToast";
import { LoadOrError } from "../../LoadOrError/LoadOrError";
import type { DirektvermarktungGeneratorShareFormValues } from "../Direktvermarktung.types";
import { useDirektvermarktungContract } from "../hooks/useDirektvermarktungContract";
import { useDirektvermarktungGeneratorShareMutations } from "../hooks/useDirektvermarktungGeneratorShareMutations";
import { DirektvermarktungGeneratorShareTable } from "./DirektvermarktungGeneratorShareTable/DirektvermarktungGeneratorShareTable";

interface DirektvermarktungContractInformationProps {
  contractId: string;
}

function DirektvermarktungContractInformation({
  contractId
}: DirektvermarktungContractInformationProps) {
  const { showToast } = useToast();

  const {
    data: contractData,
    isLoading: direktvermarktungContractLoading,
    error: direktvermarktungContractError
  } = useDirektvermarktungContract(contractId);

  const direktvermarktungGeneratorShareMutations =
    useDirektvermarktungGeneratorShareMutations({
      contractUuid: contractId
    });

  async function handleSaveGeneratorShare(
    generatorShareFormValues: DirektvermarktungGeneratorShareFormValues
  ) {
    const response =
      await direktvermarktungGeneratorShareMutations.addGeneratorShareToVermarktungContractMutation.mutateAsync(
        {
          formValues: generatorShareFormValues,
          contractId: contractId
        }
      );

    showToast({
      type: "success",
      message: "Ihr Erzeuger wurde erfolgreich gespeichert."
    });

    return response;
  }

  async function handleDeleteGeneratorShare(generatorShareId: number) {
    await direktvermarktungGeneratorShareMutations.removeGeneratorShareFromVermarktungContractMutation.mutateAsync(
      generatorShareId
    );

    showToast({
      type: "success",
      message: "Ihr Erzeuger wurde erfolgreich aus dem Vertrag entfernt."
    });
  }

  return (
    <LoadOrError
      error={direktvermarktungContractError}
      loading={
        contractData?.operator_id === undefined &&
        direktvermarktungContractLoading
      }
      loadingMessage="Verträge werden geladen ..."
    >
      {contractData && (
        <DirektvermarktungGeneratorShareTable
          contractUuid={contractData.id}
          generatorShares={contractData?.generation_shares || []}
          operatorId={contractData.operator_id}
          onDelete={handleDeleteGeneratorShare}
          onSubmit={handleSaveGeneratorShare}
        />
      )}
    </LoadOrError>
  );
}

export {
  DirektvermarktungContractInformation,
  DirektvermarktungContractInformationProps
};
